import { render, staticRenderFns } from "./SingleLoan.vue?vue&type=template&id=76822971&"
import script from "./SingleLoan.vue?vue&type=script&lang=js&"
export * from "./SingleLoan.vue?vue&type=script&lang=js&"
import style0 from "./SingleLoan.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports